export default "__VITE_ASSET__BQqv0QGz__"